export default __webpack_public_path__ + "static/media/Music Landing.21da32cd.mp3";